// Overall Frequency buckets (sec) — shared by the KPI card and the Frequency Distribution table.
// `key` is the count field returned by the KPI APIs, `field` is the count field in the
// deviceHealthCityWise table rows, `tone` drives the cell colour,
// `downloadApi` is used by the KPI bucket download.
export const BUCKET_COLUMNS = [
    { label: "0-5", field: "0-5", key: "avgDelay0To5Count", tone: "yellow", downloadApi: "downloadFrequency0to5" },
    { label: "5-10", field: "5-10", key: "avgDelay5To10Count", tone: "green", downloadApi: "downloadFrequency5to10" },
    { label: "10-20", field: "10-20", key: "avgDelay10To20Count", tone: "green", downloadApi: "downloadFrequency10to20" },
    { label: "20-30", field: "20-30", key: "avgDelay20To30Count", tone: "orange", downloadApi: "downloadFrequency20to30" },
    { label: "30-45", field: "30-45", key: "avgDelay30To45Count", tone: "orange", downloadApi: "downloadFrequency30to45" },
    { label: "45-60", field: "45-60", key: "avgDelay45To60Count", tone: "red", downloadApi: "downloadFrequency45to60" },
    { label: ">60", field: ">60", key: "avgDelayAbove60Count", tone: "red", downloadApi: "downloadFrequencyAbove60" }
];

// which bucket an average interval (sec) falls into
export const getBucketForInterval = (seconds) => {
    if (seconds <= 5) return BUCKET_COLUMNS[0];
    if (seconds <= 10) return BUCKET_COLUMNS[1];
    if (seconds <= 20) return BUCKET_COLUMNS[2];
    if (seconds <= 30) return BUCKET_COLUMNS[3];
    if (seconds <= 45) return BUCKET_COLUMNS[4];
    if (seconds <= 60) return BUCKET_COLUMNS[5];
    return BUCKET_COLUMNS[6];
};
